// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/coin/coin-16.svg

import React, { useId } from 'react';

/** Proporção nativa 16x16. */
export default function IconeCoin({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  // id único por instância: sem isto, dois gradientes iguais colidem na mesma página
  const uid = useId().replace(/:/g, '');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <defs><linearGradient id={`g-${uid}`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#FFE58A"></stop><stop offset=".5" stopColor="#FBBD04"></stop><stop offset="1" stopColor="#B8860B"></stop></linearGradient></defs><path d="M12 1.5l9.5 5.25v10.5L12 22.5l-9.5-5.25V6.75z" fill={`url(#g-${uid})`}></path><path d="M12 4.5l7 3.9v7.2l-7 3.9-7-3.9V8.4z" fill="none" stroke="#0B0D12" strokeOpacity=".35" strokeWidth="1.2"></path><path d="M8.5 8.5 12 16l3.5-7.5" fill="none" stroke="#0B0D12" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
}
